/**
 * @fileoverview Provide the calendar form's controlled Boolean switch using its value-envelope change convention. Parent Redux/form state owns the choice; the switch owns interaction and disabled presentation. A local toggle does not itself enable a backend feature or save an event.
 */

import React from 'react';
import './GlassSwitch.css';



const GlassSwitch = ({ checked = false, onChange, disabled = false }) => {
    const handleClick =

    () => {
        if (!disabled && onChange) {
            // Mimic PrimeReact's onChange signature which passes an object with 'value' property
            onChange({ value: !checked });
        }
    };

    const handleKeyPress =

    (e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className={`glass-switch ${checked ? 'glass-switch-checked' : ''} ${disabled ? 'glass-switch-disabled' : ''}`}
            onClick={handleClick}
            onKeyPress={handleKeyPress}
            role="switch"
            aria-checked={checked}
            tabIndex={disabled ? -1 : 0}
        >
            <span className="glass-switch-slider"></span>
        </div>
    );
};

export default GlassSwitch;
